import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

export default function ChatLoading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      bgcolor="#F8FAFC"
      p={2}
      pb={1}
      ml={2}
      width="fit-content"
      borderRadius="12px"
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: '#2E77D0',
            animation: `${bounce} 0.6s ease-in-out infinite`,
            animationDelay: `${i * 0.1}s`,
          }}
        />
      ))}
    </Box>
  );
}
